import { terms2SelectItem, termsSelectItem, termsTab } from '@/pages/policy/constants';
import { useState } from 'react';
import SubVisual from '@/components/SubVisual';
import PolicySelectBox from '@/pages/policy/components/PolicySelectBox';
import { Outlet } from 'react-router';

const TermsPage = () => {
	const [activeTab, setActiveTab] = useState(0);

	const handleTabChange = (index: number) => {
		setActiveTab(index);
	};

	return (
		<main id="terms" className={`sub terms`}>
			<SubVisual title={termsTab.title} subTab={termsTab.subTab} cate={''} onChangeTab={handleTabChange} />
			<section className="sub-content">
				<div className="sub-inner">
					<PolicySelectBox selectItems={activeTab === 0 ? termsSelectItem : terms2SelectItem} />
					<Outlet />
				</div>
			</section>
		</main>
	);
};

export default TermsPage;
